import { AxiosError } from "axios";

export default class BaseTemplateHandledApiError extends AxiosError {
  constructor(error: AxiosError, message?: string) {
    super(message ?? error.message, error.code, error.config, error.request, error.response);
  }
}
